const getFileNameFromUrl = (url) => {
  try {
    const pathname = new URL(url).pathname;
    const fileName = pathname.substring(pathname.lastIndexOf("/") + 1);
    return decodeURIComponent(fileName);
  } catch {
    return "document";
  }
};

export const downloadFile = async (url, name = "") => {
  if (!url) return;

  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error("Download failed");

    let fileName = name;

    // fallback → extract from URL
    if (!fileName) {
      fileName = getFileNameFromUrl(url);
    }

    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName || "document";
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }, 100);
  } catch (err) {
    console.error(err);
  }
};
